import { languageScoreLevel } from '@/api/common/master-lists'

const data = {
  items: sessionStorage.getItem('languageScoreLevels')
    ? JSON.parse(sessionStorage.getItem('languageScoreLevels'))
    : []
}

export default {
  namespaced: true,

  state () {
    return {
      ...data
    }
  },
  mutations: {
    /**
     * Reset the state to default.
     *
     * @param {*} state
     */
    RESET (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    },

    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    }
  },
  actions: {
    /**
     * Get all LanguageScoreLevel records.
     *
     * @param {*}
     */
    all ({ commit, dispatch, state }) {
      if (state.items.length) return

      return languageScoreLevel.index()
        .then(({ data }) => {
          commit('SET_ITEMS', data)

          sessionStorage.setItem('languageScoreLevels', JSON.stringify(data))
        })
        .catch(({ response }) => dispatch('httpException/handle', response, { root: true }))
    }
  }
}
